import { ToggleGroupItem } from "./ToggleGroupItem";
import { ToggleGroupRoot } from "./ToggleGroupRoot";

export const ToggleGroup = {
  Root: ToggleGroupRoot,
  Item: ToggleGroupItem,
};
